export const cartLine = `
id
quantity
horizontalImage: attribute(key: "_horizontal_image") {
  value
}
shortDescription: attribute(key: "_short_description") {
  value
}
isApparel: attribute(key: "_is_apparel") {
  value
}
apparelColor: attribute(key: "_apparel_color") {
  value
}
apparelSize: attribute(key: "_apparel_size") {
  value
}
isSimple: attribute(key: "_is_simple") {
  value
}
attributes {
  key
  value
}
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    id
    sku
    title
    priceV2 {
      amount
    }
    compareAtPrice {
      amount
    }
    product {
      ... on Product {
        id
        title
        available: availableForSale 
        handle
        description
        tags
        id
        vendor
        productType
        variants(first: 50) {
          edges {
            node {
              title
              available: availableForSale
              id
              sku
              priceV2 {
                amount
              }
              compareAtPrice {
                amount
              }
              image {
                src: url(transform: { maxHeight: 180, maxWidth: 140 })
              }
            }
          }
        }
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
attributes {
  key
  value
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const product = `
  id,
  title
  available: availableForSale
  handle
  productType
  description
  descriptionHtml
  options(first: 100) {
    name
    values
  }
  priceRange {
    minVariantPrice{
      amount
    }
  }
  images(first: 10) {
    edges {
      node {
        src
        alt: altText
        height
        width
      }
    }
  }
  media(first: 10) {
    edges {
      cursor
      node {
        alt
        mediaContentType
        previewImage {
          alt: altText
          originalSrc
          transformedSrc(maxWidth: 998, maxHeight: 1485, crop: CENTER, preferredContentType: JPG)
        }
        ... on ExternalVideo {
          id
          alt
          host
          embedUrl
          embeddedUrl
          originUrl
        }
        ... on Video {
          id
          alt
          previewImage {
            altText
            id
            url
          }
          sources {
            format
            height
            mimeType
            url
            width
          }
        }
        ... on MediaImage {
          id
          image {
            src
            alt: altText
            height
            width
          }
        }
      }
    }
  }
  afterpayMessage: metafield(namespace: "afterpay", key: "show_message") {
    value
  },
  comingSoonDate: metafield(namespace: "product", key: "coming_soon_date") {
    value
  },
  madeIn: metafield(namespace: "custom", key: "made_in") {
    value
    id
    reference {
        __typename
        ... on Metaobject {
            id
          handle
          fields {
            value
            key
            reference {
                __typename
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
        }
    }
  },
  tags,
  vendor
  variants(first: 50) {
    edges {
      node {
        id
        title
        available: availableForSale
        priceV2 {
          amount
        }
        compareAtPrice {
          amount
        }
        quantityAvailable
        sku
        selectedOptions {
          name
          value
        }
        image {
          src
          alt: altText
          height
          width
        }
        product {
            ... on Product{
                handle
                productType
                title
                id
            }
        }
        disableInCustomizer: metafield(namespace: "customizer", key: "disable_in_customizer") {
          value
        }
        backgroundColor: metafield(namespace: "customizer", key: "background_color") {
          value
        }
        customizerDescription: metafield(namespace: "customizer", key: "description") {
          value
        }
        hideOnSelection: metafield(namespace: "customizer", key: "hide_on_selection") {
          value
        }
        edgeRetentionRating: metafield(namespace: "customizer", key: "edge_retention_rating") {
          value
        }
        toughnessRating: metafield(namespace: "customizer", key: "toughness_rating") {
          value
        }
        corrosionResistanceRating: metafield(namespace: "customizer", key: "corrosion_resistance_rating") {
          value
        }
        hideUploadYourOwnArtwork: metafield(namespace: "customizer", key: "hide_upload_your_own_artwork") {
          value
        }
      }
    }
  }
  threekitAssetId: metafield(namespace: "threekit", key: "assetid") {
    id
    value
  }
  apparelColor: metafield(namespace: "custom", key: "apparel_color") {
    id
    value
  }
  apparelColorName: metafield(namespace: "custom", key: "apparel_color_name"){
    id
    value
  }
  threekitDefaultId: metafield(namespace: "customizer", key: "threekit_default_id") {
    id
    value
  }
  featuredSpecMetafields: metafields(identifiers: [
    {namespace: "featured_specs", key: "spec_1_header"},
    {namespace: "featured_specs", key: "spec_1_mobile_image"},
    {namespace: "featured_specs", key: "spec_1_text"},
    {namespace: "featured_specs", key: "spec_1_title"},
    {namespace: "featured_specs", key: "spec_1_video_time"},
    {namespace: "featured_specs", key: "spec_2_header"},
    {namespace: "featured_specs", key: "spec_2_mobile_image"},
    {namespace: "featured_specs", key: "spec_2_text"},
    {namespace: "featured_specs", key: "spec_2_title"},
    {namespace: "featured_specs", key: "spec_2_video_time"},
    {namespace: "featured_specs", key: "spec_3_header"},
    {namespace: "featured_specs", key: "spec_3_mobile_image"},
    {namespace: "featured_specs", key: "spec_3_text"},
    {namespace: "featured_specs", key: "spec_3_title"},
    {namespace: "featured_specs", key: "spec_3_video_time"},
    {namespace: "featured_specs", key: "spec_4_header"},
    {namespace: "featured_specs", key: "spec_4_mobile_image"},
    {namespace: "featured_specs", key: "spec_4_text"},
    {namespace: "featured_specs", key: "spec_4_title"},
    {namespace: "featured_specs", key: "spec_4_video_time"},
    {namespace: "featured_specs", key: "video_url"},
    {namespace: "featured_specs", key: "cta_button_style"},
    {namespace: "featured_specs", key: "cta_copy"},
    {namespace: "featured_specs", key: "cta_link"},
    {namespace: "featured_specs", key: "overview_text"}
  ]) {
    key
    namespace
    value
  }
  imageSpecMetafields: metafields(identifiers: [
    {namespace: "image_specs", key: "spec_1_title"},
    {namespace: "image_specs", key: "spec_1_header"},
    {namespace: "image_specs", key: "spec_1_text"},
    {namespace: "image_specs", key: "spec_1_image"},
    {namespace: "image_specs", key: "spec_2_title"},
    {namespace: "image_specs", key: "spec_2_header"},
    {namespace: "image_specs", key: "spec_2_text"},
    {namespace: "image_specs", key: "spec_2_image"},
    {namespace: "image_specs", key: "spec_3_title"},
    {namespace: "image_specs", key: "spec_3_header"},
    {namespace: "image_specs", key: "spec_3_text"},
    {namespace: "image_specs", key: "spec_3_image"},
    {namespace: "image_specs", key: "spec_4_title"},
    {namespace: "image_specs", key: "spec_4_header"},
    {namespace: "image_specs", key: "spec_4_text"},
    {namespace: "image_specs", key: "spec_4_image"},
    {namespace: "image_specs", key: "cta_copy"},
    {namespace: "image_specs", key: "cta_link"},
    {namespace: "image_specs", key: "overview_text"}
  ]) {
    key
    namespace
    value
  }
  highlightMetafields: metafields(identifiers: [
    {namespace: "highlight", key: "desktop_image"},
    {namespace: "highlight", key: "mobile_image"},
    {namespace: "highlight", key: "desktop_video"},
    {namespace: "highlight", key: "mobile_video"},
    {namespace: "highlight", key: "heading_1"},
    {namespace: "highlight", key: "content_1"},
    {namespace: "highlight", key: "cta_text_1"},
    {namespace: "highlight", key: "url_1"},
    {namespace: "highlight", key: "heading_2"},
    {namespace: "highlight", key: "content_2"},
    {namespace: "highlight", key: "cta_text_2"},
    {namespace: "highlight", key: "url_2"},
    {namespace: "highlight", key: "heading_3"},
    {namespace: "highlight", key: "content_3"},
    {namespace: "highlight", key: "cta_text_3"},
    {namespace: "highlight", key: "url_3"},
    {namespace: "highlight", key: "heading_4"},
    {namespace: "highlight", key: "content_4"},
    {namespace: "highlight", key: "cta_text_4"},
    {namespace: "highlight", key: "url_4"},
  ]) {
    key
    namespace
    value
    reference {
      ... on MediaImage {
        image {
          originalSrc
        }
      }
    }
  }
  specsMetafields: metafields(identifiers: [
    {namespace: "specifications", key: "open_length"},
    {namespace: "specifications", key: "blade_length"},
    {namespace: "specifications", key: "blade_thickness"},
    {namespace: "specifications", key: "closed_length"},
    {namespace: "specifications", key: "handle_thickness"},
    {namespace: "specifications", key: "hook_gap"},
    {namespace: "specifications", key: "product_box"},
    {namespace: "specifications", key: "selectedge_angle"},
    {namespace: "specifications", key: "mechanism"},
    {namespace: "specifications", key: "blade_style"},
    {namespace: "specifications", key: "handle"},
    {namespace: "specifications", key: "pocket_clip"},
    {namespace: "specifications", key: "sheath"},
    {namespace: "specifications", key: "designer"},
    {namespace: "specifications", key: "class"},
    {namespace: "specifications", key: "opening_actions"},
    {namespace: "specifications", key: "blade_finish"},
    {namespace: "specifications", key: "blade_color"},
    {namespace: "specifications", key: "clip_color"},
    {namespace: "specifications", key: "clip_finish"},
    {namespace: "specifications", key: "clip_reversible"},
    {namespace: "specifications", key: "clip_position"},
    {namespace: "specifications", key: "clip_type"},
    {namespace: "specifications", key: "ambidextrous"},
    {namespace: "specifications", key: "handle_material"},
    {namespace: "specifications", key: "handle_color"},
    {namespace: "specifications", key: "liners"},
    {namespace: "specifications", key: "liner_color"},
    {namespace: "specifications", key: "serrated"},
    {namespace: "specifications", key: "molle_compatible"},
    {namespace: "specifications", key: "glass_breaker"},
    {namespace: "specifications", key: "lanyard_hole"},
    {namespace: "specifications", key: "blade_steel"},
    {namespace: "specifications", key: "weight"},
    {namespace: "specifications", key: "material_content"},
    {namespace: "details", key: "sheath"},
    {namespace: "details", key: "sheath_weight"}
  ]) {
    key
    namespace
    value
  }
  horizontalImage: metafield(namespace: "product_card", key: "horizontal_image") {
    value
  }
  horizontalImageMobile: metafield(namespace: "product_card", key: "horizontal_image_mobile") {
    value
  }
  mediaHorizontalImage: metafield(namespace: "images", key: "horizontal") {
    value
  }
  mediaHorizontalImageMobile: metafield(namespace: "images", key: "horizontal_mobile") {
    value
  }
  edgeRetentionRating: metafield(namespace: "customizer", key: "edge_retention_rating") {
    value
  }
  toughnessRating: metafield(namespace: "customizer", key: "toughness_rating") {
    value
  }
  corrosionResistanceRating: metafield(namespace: "customizer", key: "corrosion_resistance_rating") {
    value
  }
  comingSoonListID: metafield(namespace: "coming_soon", key: "list_id") {
    value
  }
  forceNotifyCTA: metafield(namespace: "coming_soon", key: "force_notify_me_cta") {
    value
  }
`;

export const collectionProduct = `
  id
  handle
  title
  images(first: 1) {
    edges {
      node {
        src
        alt: altText
        height
        width
      }
    }
  }
  tags
  variants(first: 1) {
    edges {
      node {
        id
        quantityAvailable
        sku
        priceV2 {
          amount
        }
        compareAtPrice {
          amount
        }
      }
    }
  }
  horizontalImage: metafield(namespace: "product_card", key: "horizontal_image") {
    value
  }
`;
